import React, { useEffect, useState } from "react";
import { Card, Select, DatePicker, Typography } from "antd";
import { ArrowUpOutlined } from "@ant-design/icons";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip as RechartsTooltip,
} from "recharts";
import dayjs, { Dayjs } from 'dayjs';
import { getData } from "../../../../../../../actions/apiCall";
import { useDispatch } from "react-redux";

const { RangePicker } = DatePicker;
const { Title, Text } = Typography;
const { Option } = Select;


const ACTIVITY_STATS = [
  { label: "Calls Made", value: 24, total: "2,512", color: "#ef4444" },
  { label: "Emails Sent", value: 24, total: "2,512", color: "#22c55e" },
  { label: "Meetings Done", value: 24, total: "2,512", color: "#f59e0b" },
  { label: "WhatsApp Messages", value: 24, total: "2,512", color: "#3b82f6" },
];

const CHART_DATA = [
  { name: "Calls", value: 35, color: "#6ee7b7" },
  { name: "Emails", value: 25, color: "#06b6d4" },
  { name: "Meetings", value: 15, color: "#6366f1" },
  { name: "WhatsApp", value: 25, color: "#3b82f6" },
];

const EFFICIENCY_DATA = [
  { label: "Average Login Time", value: "9:27 AM" },
  { label: "Average Logout Time", value: "6:32 PM" },
  { label: "Average Working Hrs", value: "8 hrs 12 min" },
  { label: "Average Tasks Completion", value: "74%" },
  { label: "Average Break Time", value: "45 min" },
];



const ActivityDashboard: React.FC = () => {
   const [startDate, setStartDate] = useState<Dayjs | null>(null);
        const [employeeOptions, setEmployeeOptions] = useState<
      { value: string; label: string }[]
    >([]);

    const dispatch = useDispatch();

useEffect(() => {
  getEmployees();
}, []);

const getEmployees = async () => {
  const res = await dispatch(getData('/users')); 

  if (res?.data) {
    const options = res.data.map((item: any) => ({
      value: item.firstName, 
      label: item.firstName,
    }));

    setEmployeeOptions(options);
  }
};

     const disabledDate = (current: Dayjs) => {

    if (startDate) {
      return current.isBefore(startDate.startOf('day'));
    }
    return false;
  };
  return (
    <div className="mb-4 font-sans">
      {/* HEADER */}
      <div className="flex justify-between items-center py-2">
        <Title level={5} className="!m-0 !text-sm font-bold">
          Activity Log
        </Title>

        <div className="flex space-x-4 items-center">
           <Select  defaultValue="Priya sharma" options={employeeOptions} style={{ width: 180 }} />
          <Select placeholder="Select Period" style={{ width: 150 }}>
            <Option value="month">This Month</Option>
            <Option value="quarter">This Quarter</Option>
          </Select>
         <RangePicker  style={{ width: 220 }}  disabledDate={disabledDate}
            onCalendarChange={(dates) => {
              setStartDate(dates?.[0] || null);
            }} />

        </div>
      </div>


      <div className="flex h-[420px]">

        <div className="w-70  flex flex-col justify-between h-full">
          {ACTIVITY_STATS.map((stat, i) => (
            <div
              key={i}
              className="bg-white h-23 rounded-lg flex border border-gray-100 relative"
            >
              <div className="w-1.5" style={{ backgroundColor: stat.color }} />

              <div className="flex-1 px-3 py-2">
                <div className="text-[11px] font-bold text-gray-400 uppercase">
                  {stat.label}
                </div>
                <div className="text-2xl font-black leading-tight">
                  {stat.value}
                </div>
                <div className="text-[10px] text-gray-400">
                  Total: {stat.total}
                </div>
              </div>

              <div className="absolute top-2 right-2 w-6 h-6 rounded-full border flex items-center justify-center">
                <ArrowUpOutlined
                  rotate={45}
                  style={{ fontSize: 10, color: stat.color }}
                />
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-1 gap-4 pl-4 h-full">

          <Card className="flex-1 rounded-lg h-full">
            <div className="font-bold text-sm mb-4 pb-2 border-b border-gray-200">
              Activity Overview
            </div>

            <div className="relative h-[260px]">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={CHART_DATA}
                    innerRadius={60}
                    outerRadius={95}
                    dataKey="value"
                    stroke="none"
                  >
                    {CHART_DATA.map((item, idx) => (
                      <Cell key={idx} fill={item.color} />
                    ))}
                  </Pie>
                  <RechartsTooltip />
                </PieChart>
              </ResponsiveContainer>

              <div className="absolute top-[42%] left-[38%] bg-white px-2 py-1 text-[10px] font-bold text-indigo-500 border shadow rounded">
                Meetings 32
              </div>
            </div>

            <div className="flex justify-center gap-6 mt-4">
              {CHART_DATA.map((item) => (
                <div key={item.name} className="flex items-center gap-2">
                  <div
                    className="w-4 h-2 rounded"
                    style={{ backgroundColor: item.color }}
                  />
                  <span className="text-[11px] font-semibold text-gray-400">
                    {item.name}
                  </span>
                </div>
              ))}
            </div>
          </Card>

          {/* RIGHT CARD */}
          {/* ✅ h-full */}
          <Card className="flex-1 rounded-lg h-full">
            <div className="font-bold text-sm mb-6 border-b border-gray-200 pb-2">
              Work Efficiency Overview
            </div>

            <div className="space-y-5">
              {EFFICIENCY_DATA.map((item, idx) => (
                <div
                  key={idx}
                  className="flex justify-between border-b border-gray-100 pb-2 last:border-0"
                >
                  <Text className="font-bold text-gray-700">
                    {item.label}
                  </Text>
                  <Text className="font-bold">
                    {item.value}
                  </Text>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};


export default ActivityDashboard;
